/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Nucleus Admin API
 * Headless, multi-tenant commerce backend for jewelry brands.
 *
 * ## Surfaces
 *
 * | Prefix | Caller | Credential |
 * |---|---|---|
 * | `/platform/v1` | Platform operator | Platform token from **Platform: Auth** |
 * | `/admin/v1` | Staff of one organization | Staff token from **Admin: Auth** |
 * | `/storefront/v1` | A storefront | Store API key from **Admin: API keys** |
 * | `/public/v1` | Anyone (the brand application form) | None; rate limited per IP |
 *
 * Every credential is sent as `Authorization: Bearer <value>`. Use the **Authorize** button once and it applies to every request you try here.
 *
 * ## Conventions
 *
 * - **Ids** are UUID v7 strings. **Timestamps** are ISO 8601 in UTC. **Money** is `{ amount, currency }` with `amount` in integer minor units.
 * - **Lists** paginate by cursor: `?limit=20&cursor=...` in, `{ items, nextCursor }` out, `nextCursor` is `null` on the last page.
 * - **Errors** always use one envelope, `{ error: { code, message, requestId, details?, meta? } }`. Switch on `code`, never on `message`.
 * - **Request ids**: every response carries `x-request-id`. Quote it when reporting a problem.
 * - **Idempotency**: endpoints that create money-related state require an `Idempotency-Key` header; the header is listed on those endpoints.
 * - A record that belongs to another tenant answers **404**, never 403, so existence is not leaked.
 * OpenAPI spec version: 0.1.0
 */
import type {
  GetAdminV1StoresStoreIdReturns200,
  GetAdminV1StoresStoreIdReturnsIdPathParameters,
  GetAdminV1StoresStoreIdReturnsParams,
  GetAdminV1StoresStoreIdReturnsPathParameters,
  PatchAdminV1StoresStoreIdReturnsIdBody,
  PatchAdminV1StoresStoreIdReturnsIdPathParameters,
  PostAdminV1StoresStoreIdOrdersIdReturnsBody,
  PostAdminV1StoresStoreIdOrdersIdReturnsPathParameters,
  PostAdminV1StoresStoreIdReturnsIdResolveBody,
  PostAdminV1StoresStoreIdReturnsIdResolvePathParameters,
  ReturnDetail,
  ReturnResolved
} from '../model';

import { customInstance } from '../../../transport/mutator';
import type { BodyType } from '../../../transport/mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Returns of the store, newest first
 */
export const getAdminV1StoresStoreIdReturns = (
    { storeId }: GetAdminV1StoresStoreIdReturnsPathParameters,
    params?: GetAdminV1StoresStoreIdReturnsParams,
 options?: SecondParameter<typeof customInstance<GetAdminV1StoresStoreIdReturns200>>,) => {
      return customInstance<GetAdminV1StoresStoreIdReturns200>(
      {url: `/admin/v1/stores/${storeId}/returns`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Only shipped units not already inside another return can be requested; the store's return window does not apply to staff
 * @summary Open a return on behalf of the shopper
 */
export const postAdminV1StoresStoreIdOrdersIdReturns = (
    { storeId, id }: PostAdminV1StoresStoreIdOrdersIdReturnsPathParameters,
    postAdminV1StoresStoreIdOrdersIdReturnsBody: BodyType<PostAdminV1StoresStoreIdOrdersIdReturnsBody>,
 options?: SecondParameter<typeof customInstance<ReturnDetail>>,) => {
      return customInstance<ReturnDetail>(
      {url: `/admin/v1/stores/${storeId}/orders/${id}/returns`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAdminV1StoresStoreIdOrdersIdReturnsBody
    },
      options);
    }
  /**
 * allowedResolutions lists what this caller may resolve it as: refund needs orders.refund, store_credit gift_cards.write
 * @summary One return
 */
export const getAdminV1StoresStoreIdReturnsId = (
    { storeId, id }: GetAdminV1StoresStoreIdReturnsIdPathParameters,
 options?: SecondParameter<typeof customInstance<ReturnDetail>>,) => {
      return customInstance<ReturnDetail>(
      {url: `/admin/v1/stores/${storeId}/returns/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * requested → approved → in_transit → received → inspected, rejected from requested, cancelled from any open state; inspected needs a condition on every line
 * @summary Move the return along, record conditions and notes
 */
export const patchAdminV1StoresStoreIdReturnsId = (
    { storeId, id }: PatchAdminV1StoresStoreIdReturnsIdPathParameters,
    patchAdminV1StoresStoreIdReturnsIdBody: BodyType<PatchAdminV1StoresStoreIdReturnsIdBody>,
 options?: SecondParameter<typeof customInstance<ReturnDetail>>,) => {
      return customInstance<ReturnDetail>(
      {url: `/admin/v1/stores/${storeId}/returns/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchAdminV1StoresStoreIdReturnsIdBody
    },
      options);
    }
  /**
 * refund records a refund on the order's payment or gift cards and needs orders.refund; store_credit issues a gift card whose code appears in this response only and needs gift_cards.write; exchange, repair and resize are recorded for the follow-up. Restock puts non-damaged units back on hand
 * @summary Resolve an inspected return
 */
export const postAdminV1StoresStoreIdReturnsIdResolve = (
    { storeId, id }: PostAdminV1StoresStoreIdReturnsIdResolvePathParameters,
    postAdminV1StoresStoreIdReturnsIdResolveBody: BodyType<PostAdminV1StoresStoreIdReturnsIdResolveBody>,
 options?: SecondParameter<typeof customInstance<ReturnResolved>>,) => {
      return customInstance<ReturnResolved>(
      {url: `/admin/v1/stores/${storeId}/returns/${id}/resolve`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAdminV1StoresStoreIdReturnsIdResolveBody
    },
      options);
    }
  export type GetAdminV1StoresStoreIdReturnsResult = NonNullable<Awaited<ReturnType<typeof getAdminV1StoresStoreIdReturns>>>
export type PostAdminV1StoresStoreIdOrdersIdReturnsResult = NonNullable<Awaited<ReturnType<typeof postAdminV1StoresStoreIdOrdersIdReturns>>>
export type GetAdminV1StoresStoreIdReturnsIdResult = NonNullable<Awaited<ReturnType<typeof getAdminV1StoresStoreIdReturnsId>>>
export type PatchAdminV1StoresStoreIdReturnsIdResult = NonNullable<Awaited<ReturnType<typeof patchAdminV1StoresStoreIdReturnsId>>>
export type PostAdminV1StoresStoreIdReturnsIdResolveResult = NonNullable<Awaited<ReturnType<typeof postAdminV1StoresStoreIdReturnsIdResolve>>>
